import React, { useContext, useEffect, useState, useRef } from "react";
import { ScreenContext } from "../../../contexts/ScreenContext";
import ChatWindow from "../ChatWindow";
import ChatWindowView from "../ChatWindowView";
import useDetectKeyboardOpen from "use-detect-keyboard-open";
import useMobileViewportHeight from "../../hooks/useMobileViewHeight";
import { DeviceContext } from "../../../contexts/DeviceContext";
import { ChatContext } from "../../../contexts/ChatContext";

export default function ChatSlider({
  toggleChatWindow = null,
  chatItem,
  animationDirection = "slide-x",
}) {
  const { isActiveBurger, inMobileView } = useContext(ScreenContext);
  const isKeyboardOpen = useDetectKeyboardOpen();
  const sliderRef = useRef(null);
  const [viewport, handleResize] = useMobileViewportHeight(sliderRef, false);
  const { isIOS14, isIOS15, isIOSChrome, isAndroidChrome, osVersion, sizes } =
    useContext(DeviceContext);

  const { toggleChat, setToggleChat } = useContext(ChatContext);
  const [delayBottom, setDelayBottom] = useState(false);

  //Making sure that data is correct from invited chat state or from list
  const currentChatItem = chatItem
    ? chatItem.hasOwnProperty("props")
      ? chatItem.props
      : chatItem[1].props
    : null;

  //Define default animation state
  const isVerticalAnimation = animationDirection == "slide-y";
  let sliderNavigation = `chat-slider__nav-back`;
  let sliderAnimationClass = `chat-slider__slide-x ${
    toggleChat
      ? "chat-slider__slide-x--slide-in"
      : "chat-slider__slide-x--slide-out"
  }
  ${isActiveBurger ? "chat-slider--reduce-height" : ""}
  `;

  //Changing animation direction for public chat
  if (isVerticalAnimation) {
    sliderAnimationClass = `chat-slider__slide-y ${
      toggleChat
        ? "chat-slider__slide-y--slide-up"
        : "chat-slider__slide-y--slide-down"
    }
    ${isActiveBurger ? "chat-slider--reduce-height" : ""}
    `;
  }

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const getViewportHeight = () => {
    return visualViewport.height + "px";
  };

  const wrapMobile = document.querySelector(".wrap-mobile");

  useEffect(() => {
    if (wrapMobile) {
      if (toggleChat) {
        wrapMobile.style.overflow = "hidden";
        wrapMobile.style.height = getViewportHeight();
        document.querySelector("body").style.overflow = "hidden";
        document.querySelector("body").style.height = getViewportHeight();
        document.documentElement.style.height = getViewportHeight();
        scrollToTop();
      }

      return () => {
        wrapMobile.style.overflow = "";
        wrapMobile.style.height = "";

        document.querySelector("body").style.height = "";
        document.querySelector("body").style.overflow = "";
        document.documentElement.style.height = "";
      };
    }
  }, [isKeyboardOpen, viewport, toggleChat]);

  let supportsPassive = false;
  try {
    window.addEventListener(
      "",
      null,
      Object.defineProperty({}, "passive", {
        get: function () {
          supportsPassive = true;
        },
      })
    );
  } catch (e) {}

  let wheelOpt = supportsPassive ? { passive: false } : false;

  let element = window;

  const hasParentClass = (element, className) => {
    if (!element.parentNode) {
      return false;
    }

    if (hasClass(element, className)) {
      return true;
    }

    return hasParentClass(element.parentNode, className);
  };

  const hasClass = (element, className) => {
    return element.classList.contains(className);
  };

  const preventGlobalScroll = (e) => {
    const isNavBar = hasParentClass(e.target, "mobile-nav");
    const isChatPublic = hasParentClass(e.target, "chat-slider__slide-y");
    const isChatPrivate = hasParentClass(e.target, "chat-slider__slide-x");
    const isModalBackdrop = hasParentClass(e.target, "modal-backdrop") && hasParentClass(e.target, "show") 
    const isModal = hasParentClass(e.target, "modal") && hasParentClass(e.target, "show") 
    if (isChatPublic || isNavBar || isChatPrivate || isModal || isModalBackdrop) {
      disableGlobalScroll();
    } else {
      e.preventDefault();
    }
  };

  const enableGlobalScroll = () => {
    element.removeEventListener("touchmove", preventGlobalScroll, wheelOpt);
    element.removeEventListener("touchstart", preventGlobalScroll, wheelOpt);
    element.removeEventListener(
      "DOMMouseScroll",
      preventGlobalScroll,
      wheelOpt
    );
  };

  const disableGlobalScroll = () => {
    element.addEventListener("DOMMouseScroll", preventGlobalScroll, wheelOpt);
    element.addEventListener("touchmove", preventGlobalScroll, wheelOpt);
    element.addEventListener("touchstart", preventGlobalScroll, wheelOpt);
  };

  //Disabling scroll when clicking outside
  useEffect(() => {
    if (toggleChat && isVerticalAnimation === true) {
      disableGlobalScroll();

      return () => {
        enableGlobalScroll();
      };
    }
  }, [toggleChat]);

  const renderNavContent = (props) => {
    return (
      <>
        <div
          className={sliderNavigation}
          style={{
            order: `${isVerticalAnimation ? "1" : "0"}`,
            position: "relative",
            left: `${isVerticalAnimation ? "-15px" : "0"}`,
            marginRight: isVerticalAnimation ? "0" : "20px",
          }}
        >
          <img
            className={`${
              isVerticalAnimation
                ? `${
                    toggleChat
                      ? "chat-slider__nav-back-rotated--down"
                      : "chat-slider__nav-back-rotated"
                  }`
                : ""
            }`}
            width="24px"
            src="/assets/back-framed.svg"
          />
        </div>
        <div className="chat-slider__nav-info">
          {`${
            props.type === "public"
              ? "Live Chat"
              : props.listItemTitle
              ? props.listItemTitle
              : props.tabTitle
          }`}
        </div>
      </>
    );
  };

  const onClickHandler = (props) => {
    if (toggleChatWindow != null) {
      toggleChatWindow(null);
    } else {
      setToggleChat((prev) => !prev);
    }

    if (props.type === "private" || props.type === "corporate") {
      props.onListItemClick();
    }
  };

  //Delaying publicchat toggle
  useEffect(() => {
    let timer = null;
    if (isVerticalAnimation && inMobileView === "home") {
      timer = setTimeout(() => setToggleChat(true), 100);
    }
    return () => clearTimeout(timer);
  }, [isVerticalAnimation, inMobileView]);

  //Hiding bottom bar
  useEffect(() => {
    let timer = null;
    if (!toggleChat) {
      timer = setTimeout(() => setDelayBottom(true), 250);
    }
    setDelayBottom(false);
    return () => clearTimeout(timer);
  }, [toggleChat]);

  //Disabling chat when not in view
  useEffect(() => {
    if (inMobileView != "home") {
      if (toggleChat) {
        setToggleChat(false);
      }
    }
  }, [inMobileView]);

  return (
    <div
      ref={sliderRef}
      className={`${sliderAnimationClass} ${
        isKeyboardOpen ? "keyboard-open" : ""
      } `}
      style={{ "--viewport-height": getViewportHeight() }}
    >
      <>
        {currentChatItem && (
          <ChatWindow {...currentChatItem}>
            {(props) => {
              return (
                <>
                  <div
                    className="chat-slider__nav"
                    style={{
                      justifyContent: `${
                        isVerticalAnimation ? "space-between" : "flex-start"
                      }`,
                    }}
                    onClick={() => onClickHandler(props)}
                  >
                    {renderNavContent(props)}
                  </div>
                  <ChatWindowView {...props} tabIsOpen={true} />
                  {!isKeyboardOpen && delayBottom && isVerticalAnimation && (
                    <div
                      onClick={() => onClickHandler(props)}
                      className="ios14-bottom-bar"
                    >
                      {renderNavContent(props)}
                    </div>
                  )}
                </>
              );
            }}
          </ChatWindow>
        )}
      </>
    </div>
  );
}
